import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'vnm-empty-message',
  templateUrl: './empty-message.component.html',
  styleUrls: ['./empty-message.component.scss']
})
export class EmptyMessageComponent {
  @Input() icon: IconProp = 'truck-loading';
  @Input() message = 'app.no-data';
  @Input() loading = false;
  @Input() loadingIcon: IconProp = 'spinner-third';
  @Input() loadingMessage = 'app.loading-data';
  @Input() noMessage = false;

  @ContentChild('messageActions') messageActions: TemplateRef<void> | null;

  get messageText(): string {
    if (this.noMessage) {
      return;
    }
    if (this.loading && this.loadingMessage) {
      return this.loadingMessage;
    }

    return this.message;
  }

  get iconValue() {
    if (this.loading) {
      return this.loadingIcon;
    }

    return this.icon;
  }
}
